import V2 from "./v2/help";

export default function Entry(props) {
    return <V2 {...props} />;
}
